/**
 * True only inside the Capacitor app build (`apps/capacitor` sets `public.NUXT_CAPACITOR_APP`).
 *
 * Base-layer code is shared with `apps/web`, so anything that reaches for a native bridge or for
 * the Capacitor-only connectivity machinery must gate on this. Unlike
 * `apps/capacitor/utils/isCapacitorNativeApp`, this does not exclude the Capacitor web preview:
 * it answers "which app bundle am I in", not "am I on a device".
 */
export function isCapacitorShell(): boolean {
    const config = useRuntimeConfig() as { public?: { NUXT_CAPACITOR_APP?: boolean } }
    return Boolean(config.public?.NUXT_CAPACITOR_APP)
}
